import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import englishTranslation from 'public/locales/en/translation.json'
import spanishTranslation from 'public/locales/es/translation.json'
import vietnameseTranslation from 'public/locales/vi/translation.json'
import somaliTranslation from 'public/locales/so/translation.json'
import hmongTranslation from 'public/locales/hmn/translation.json'
import russianTranslation from 'public/locales/ru/translation.json'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    resources: {
      en: {
        translation: englishTranslation,
      },
      es: {
        translation: spanishTranslation,
      },
      vi: {
        translation: vietnameseTranslation,
      },
      so: {
        translation: somaliTranslation,
      },
      hmn: {
        translation: hmongTranslation,
      },
      ru: {
        translation: russianTranslation,
      },
    },
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
